import React, { useContext } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Navbar from "./components/navbar";
import { AppContext } from './context/appContext';

const Header = () => {
  const { Message, dispatch } = useContext(AppContext);

  return (
    <>
      <Navbar />
      {Message &&
      <Dialog maxWidth={'sm'} fullWidth={true} open={Message !== null}>
        <DialogTitle>{Message.title}</DialogTitle>
        <DialogContent dividers>
          {Message && Message.lines.map((line, index) => {
            return <div key={index}>{line}</div>
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dispatch({type: 'CLEAR_MESSAGE'})}>Close</Button>
        </DialogActions>
      </Dialog>
      }
    </>
  )

}

export default Header;